import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadService } from "../../../api/services/uploadService";
import { fileStatusKeys } from "./useFileStatus";

interface UploadFilesParams {
  files: File[];
  docType: string;
  userEmail: string;
  dbName: string;
}

interface UploadResult {
  succeeded: string[];
  failed: string[];
}

export function useFileUpload() {
  const queryClient = useQueryClient();

  return useMutation<UploadResult, Error, UploadFilesParams>({
    mutationFn: async ({ files, docType, userEmail, dbName }) => {
      return uploadService.uploadFiles(files, docType, userEmail, dbName);
    },
    onSuccess: (_, variables) => {
      const datetime = new Date().toISOString().slice(0, 10);
      queryClient.invalidateQueries({
        queryKey: fileStatusKeys.list(variables.docType, datetime),
      });
    },
  });
}
